import React, { useContext } from "react";
import { useState, useEffect } from "react";
import {
  TextField,
  FormLabel,
  FormGroup,
  Button,
  Grid,
  Paper,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";

import { ClientTable } from "./clientTables";
import DataContext from "../../context/DataContext";

import { useToasts } from "react-toast-notifications";

function ClientForm() {
  let { APIData, update, addObj, setArchivedClients } = useContext(DataContext);
  const [name, setName] = useState(null);
  const [clientId, setClientId] = useState(null);

  const { addToast } = useToasts();
  async function onSubmit() {
    let data = { name };
    if (name != null && name != "") {
      //TODO: create new client with id
      var client = {
        name: name,
        id: Date.now(),
        date_modified: new Date().toLocaleString(),
        archived: false,
      };
      addObj(client, true);

      await new Promise((r) => setTimeout(r, 500));
      addToast("Client created successfully", { appearance: "success" });

      setName(null);
      setClientId(null);

      // APIData.post("/client/", data)
      //   .then((res) => {
      //     addToast("Client created successfully", { appearance: "success" });
      //     setName(null);
      //     setClientId(null);
      //     addObj(res.data, true);
      //   })
      //   .catch((error) => {
      //     addToast(error.message, { appearance: "error" });
      //   });
    }
  }

  async function onUpdate(id) {
    let item = { name };
    if (clientId != null)
      if (name != null && name != "") {
        setName(null);
        setClientId(null);

        //TODO: grab client with id and update name
        var client = {
          name: name,
          date_modified: new Date().toLocaleString(),
          id: id,
        };
        console.log(client);

        await new Promise((r) => setTimeout(r, 500));
        update(client, true);
        addToast("Client updated successfully", { appearance: "success" });

        // APIData.patch(`/client/${id}/`, item)
        //   .then((res) => {
        //     addToast("Client updated successfully", { appearance: "success" });
        //     setName(null);
        //     setClientId(null);
        //     update(res.data, true);
        //   })
        //   .catch((error) => {
        //     addToast(error.message, { appearance: "error" });
        //     //too do: logout if 501
        //   });
      }
  }

  return (
    <Paper
      elevation={3}
      // spacing={2}
      style={{
        padding: 8,
      }}
    >
      <Grid container>
        <Grid
          container
          item
          xl={6}
          lg={6}
          sm={12}
          xs={12}
          padding={4}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <FormLabel></FormLabel>
            <TextField
              required
              id="clientName-input"
              // variant="outlined"
              name="clientName"
              label="Client Name"
              type="text"
              value={name || ""}
              variant="filled"
              onChange={(e) => setName(e.target.value)}
              style={{
                margin: "5px 5px 5px 5px",
              }}
            />
            <FormGroup
              row
              style={{
                margin: "5px 5px 5px 5px",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={() => onSubmit()}
              >
                Submit
              </Button>
              <Button
                disabled={clientId == null}
                variant="contained"
                color="primary"
                type="submit"
                onClick={() => onUpdate(clientId)}
              >
                Update
              </Button>
            </FormGroup>
          </form>
        </Grid>
        {/* <div style={{ height: 600, width: 400 }}> */}
        <Grid item xl={6} lg={6} sm={12} xs={12}>
          <ClientTable
            clientId={clientId}
            setClientId={setClientId}
            setName={setName}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default React.memo(ClientForm);
